import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from '../lib/local-storage.service';
import { RequestQueueService } from '../lib/request-queue.service';
import * as AppSelectors from './../store/selectors/app.selectors';
import { UtilsService } from '../lib/utils.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor, OnDestroy {

  constructor(private localStorageService: LocalStorageService,
    private queueService: RequestQueueService,
    private utilService: UtilsService,
    private store: Store<{}>
  ) {

    this.queueHttpRequests$.pipe(takeUntil(this.destroy$)).subscribe((queueHttpRequests) => {
      this.queueHttpRequests = queueHttpRequests;
    });

  }

  destroy$: Subject<boolean> = new Subject<boolean>();

  queueHttpRequests$: Observable<boolean> = this.store.pipe(select(AppSelectors.selectQueueHttpRequests));
  queueHttpRequests: boolean = false;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const headers: any = {
      'Content-Type': `application/json; charset=utf-8`,
      DEVICEID: this.localStorageService.getDeviceId(),
      SEQUENCE: '1'
    };

    const isLogoutRequest = request.url.indexOf("logOut") > -1;

    if (request.url.indexOf('/employees/') < 0 || isLogoutRequest) {
      const token = this.localStorageService.getServerToken()
      if (token) {
        headers.TOKEN = this.localStorageService.getServerToken();
      }
    }

    request = request.clone({
      setHeaders: headers
    });

    this.utilService.setRequestIsInProgress(true);

    return this.queueHttpRequests && !isLogoutRequest ? this.queueService.intercept(request, next) : next.handle(request);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
